
/*
 * Podere La Botta — Header Socials v1.0 / Shopify Horizon
 * Riutilizza le icone e gli URL già configurati nel blocco social del Footer.
 * Desktop: seconda riga sotto account/carrello.
 * Mobile: accanto alla localizzazione nell'hamburger.
 * Non modifica il comportamento del carrello o del menu.
 */
(() => {
  'use strict';
  if (window.__plbHeaderSocialsInitialized) return;
  window.__plbHeaderSocialsInitialized = true;

  const SOURCE = [
    '#footer-group .social-icons__wrapper a[href]',
    'footer .social-icons__wrapper a[href]',
    '#footer-group .social-icons a[href]',
    'footer .social-icons a[href]',
    '#footer-group .social-media-links a[href]',
    'footer .social-media-links a[href]'
  ].join(',');

  const HOST_DESKTOP = '#header-group header-actions';
  const HOST_MOBILE = '#header-group .menu-drawer__utility-links';

  let scheduled = false;
  let lastSignature = '';

  function sourceLinks() {
    const nodes = Array.from(document.querySelectorAll(SOURCE));
    const seen = new Set();

    return nodes.filter(a => {
      const url = a.getAttribute('href') || '';

      // Non copiare pulsanti senza collegamento o anchor interni.
      if (
        !url ||
        url === '#' ||
        url.startsWith('javascript:') ||
        seen.has(url)
      ) return false;

      seen.add(url);
      return true;
    });
  }

  function signature(links) {
    return links.map(a => [
      a.getAttribute('href') || '',
      a.getAttribute('aria-label') || '',
      a.innerHTML
    ].join('|')).join('\n');
  }

  function socialNav(links, desktop) {
    const nav = document.createElement('nav');

    nav.className =
      'plb-header-socials ' +
      (desktop
        ? 'plb-header-socials--desktop'
        : 'plb-header-socials--mobile');

    nav.setAttribute('aria-label', 'Seguici sui social');
    nav.setAttribute(
      'data-plb-header-socials',
      desktop ? 'desktop' : 'mobile'
    );

    links.forEach(source => {
      const a = document.createElement('a');
      const href = source.getAttribute('href');

      a.href = href;
      a.className = 'plb-header-socials__link';
      a.target = '_blank';
      a.rel = 'noopener noreferrer';

      const label =
        source.getAttribute('aria-label') ||
        source.getAttribute('title') ||
        '';

      if (label) {
        a.setAttribute('aria-label', label);
      } else {
        try {
          const host = new URL(
            href,
            location.origin
          ).hostname.replace(/^www\./, '');

          a.setAttribute('aria-label', 'Apri ' + host);
        } catch (_) {
          a.setAttribute('aria-label', 'Apri social');
        }
      }

      // Copia le icone già generate da Horizon.
      
const svg = source.querySelector('svg');

if (svg) {
  const icon = svg.cloneNode(true);

  icon.querySelectorAll(
    'title, desc, text, tspan, foreignObject'
  ).forEach(el => el.remove());

  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');

  a.appendChild(icon);
}

if (a.querySelector('svg')) {
  nav.appendChild(a);
}


      nav.appendChild(a);
    });

    return nav;
  }

  function sync() {
    scheduled = false;

    const links = sourceLinks();
    const desktop = document.querySelector(HOST_DESKTOP);
    const mobile = document.querySelector(HOST_MOBILE);
    const currentSig = signature(links);

    if (!links.length) {
      document
        .querySelectorAll('[data-plb-header-socials]')
        .forEach(el => el.remove());

      lastSignature = '';
      return;
    }

    if (desktop) {
      const existing = desktop.querySelector(
        ':scope > [data-plb-header-socials="desktop"]'
      );

      if (!existing || currentSig !== lastSignature) {
        existing?.remove();
        desktop.appendChild(socialNav(links, true));
      }
    }

    if (mobile) {
      const existing = mobile.querySelector(
        ':scope > [data-plb-header-socials="mobile"]'
      );

      if (!existing || currentSig !== lastSignature) {
        existing?.remove();
        mobile.appendChild(socialNav(links, false));
      }
    }

    // Rimuove eventuali duplicati dopo gli aggiornamenti di Horizon.
    document.querySelectorAll(
      '#header-group [data-plb-header-socials]'
    ).forEach(el => {
      if (
        el.dataset.plbHeaderSocials === 'desktop' &&
        el.parentElement !== desktop
      ) {
        el.remove();
      }

      if (
        el.dataset.plbHeaderSocials === 'mobile' &&
        el.parentElement !== mobile
      ) {
        el.remove();
      }
    });

    lastSignature = currentSig;
  }

  function queue() {
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    queue();

    // Aggiorna i social se Horizon ricrea parti dell'Header.
    const observer = new MutationObserver(records => {
      const relevant = records.some(r => {
        const elem =
          r.target.nodeType === Node.ELEMENT_NODE
            ? r.target
            : r.target.parentElement;

        return !elem?.closest?.(
          '[data-plb-header-socials]'
        );
      });

      if (relevant) queue();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      'shopify:section:load',
      queue
    );

    document.addEventListener(
      'shopify:section:unload',
      queue
    );

    window.addEventListener('pageshow', queue);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
